import { Component, OnInit } from '@angular/core';
import { Logger } from '@clickd-angular/common-lib';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'com-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  private textToShow: string;
  public safeHtml: SafeHtml;

  constructor(private logger: Logger,
              private router: Router,
              private sanitizer: DomSanitizer,
              private translationService: TranslateService) {
    logger.error('Angular router could not find the given rout: ' + this.router.url);
  }

  ngOnInit() {
    this.textToShow = this.translationService.instant('PAGES_APP.PAGE_NOT_FOUND_ERROR');
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.textToShow);
  }
}
